import { createFileRoute } from '@tanstack/react-router';
import { AccountabilityChart } from '~/components/ninety/AccountabilityChart';

export const Route = createFileRoute('/_app/ninety/accountability')({
  component: AccountabilityChart,
});
